import { vuexfireMutations } from 'vuexfire'
import { firestore } from '@/plugins/firestore'
import { config } from '~/components/common/config'

const COLLECTION_NAME_OPERATOR = config.operatorCollectionName()

export const mutations = {
  ...vuexfireMutations,

  updatePhoneNumber(state, { phoneNumber }) {
    state.phoneNumber = phoneNumber
  },
  updateVerCode(state, { verCode }) {
    state.verCode = verCode
  },
  updateUserId(state, { userID }) {
    state.userID = userID
  },
  updateCurrentVehicleId(state, { vehicleID }) {
    state.vehicleID = vehicleID
  },
  updateCurrentVehicleName(state, { vehicleName }) {
    state.vehicleName = vehicleName
  },
  updateDriverMessages(state, { driverMes }) {
    state.driverMes = driverMes
  },
  updateOperatorMessages(state, { opMes }) {
    state.opMes = opMes
  },
  updateTimeBuffer(state, { timeBuffer }) {
    state.timeBuffer = timeBuffer
  },
  updateStatusConfirme(state, { confirme }) {
    state.statusConfirme = confirme
  },
  updateStatusVehicle(state, { vehicleStatus }) {
    state.vehicleStatus = vehicleStatus
  },
  updateMapType(state, { maptype }) {
    state.maptype = maptype
  },
  updateSetHeadingUp(state, { isHeadingUp }) {
    state.isHeadingUp = isHeadingUp
  }
}

export const state = () => ({
  phoneNumber: '',
  verCode: '',
  userID: '',
  vehicleID: '',
  vehicleName: '',
  vehicleStatus: 'INACTIVE',
  driverMes: '',
  opMes: '',
  maptype: 'roadmap',
  isHeadingUp: false,
  timeBuffer: '',
  statusConfirme: ''
})

export const actions = {
  setOperatorAvailability: ({ state }, { available }) => {
    if (state.auth && state.auth.user && state.auth.user.id) {
      const data = { id: state.auth.user.id, available }
      return firestore
        .collection(COLLECTION_NAME_OPERATOR)
        .doc(`operator${state.auth.user.id}`)
        .set(data)
        .then(() => {
          return data.id
        })
    }
    return Promise.reject(new Error('Not authorized'))
  }
}
